export default __webpack_public_path__ + "static/media/nfo-date.8dc527ea.png";